import { lazy } from 'react';
import {
  organizationsMenuIcon,
  SearchMenuIcon,
  usersMenuIcon,
  VendorIcon
} from '@tools/ui/assets';
import Feedback from '@tools/ui/components/common/Feedback';
import { semanticTheme } from '@tools/ui/dime';
import { AppRouter } from '@tools/ui/types';
import {
  APP_PREFIX,
  ORG_REDIRECT_URL,
  VENDOR_VIEW_URL
} from '../consts/route.consts';
import { PATH_FINDER_FEEDBACK_CHANNEL } from '../consts/sharedVariables';
import { userViewRoutes } from './userView.routes';

const UserSearchView = lazy(
  () =>
    import(
      /* webpackChunkName: "SubscriptionRoutes" */ '../pages/user/UserSearchView'
    )
);

const OrganizationSearchView = lazy(
  () =>
    import(
      /* webpackChunkName: "SubscriptionRoutes" */ '../pages/organization/OrganizationSearchView'
    )
);

const VendorView = lazy(
  () =>
    import(
      /* webpackChunkName: "SubscriptionRoutes" */ '../pages/vendor/VendorTable'
    )
);

const UserViewInvestigationView = lazy(
  () =>
    import(
      /* webpackChunkName: "SubscriptionRoutes" */ '../pages/user/UserView'
    )
);

const VendorPageInvestigationView = lazy(
  () =>
    import(
      /* webpackChunkName: "SubscriptionRoutes" */ '../pages/vendor/VendorPageView'
    )
);

const OrgRedirect = lazy(
  () =>
    import(
      /* webpackChunkName: "SubscriptionRoutes" */ '../pages/organization/OrgRedirect'
    )
);

const FindPaymentsView = lazy(
  () =>
    import(
      /* webpackChunkName: "SubscriptionRoutes" */ '../pages/components/main/payments/FindPaymentsView'
    )
);

export const pathFinderRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [APP_PREFIX, `${APP_PREFIX}/organizations`]
    },
    {
      name: 'Find Payments',
      path: `${APP_PREFIX}/payments`,
      pages: [],
      component: FindPaymentsView,
      icon: SearchMenuIcon,
      exact: true
    },
    {
      name: 'Find Organizations',
      path: `${APP_PREFIX}/organizations`,
      pages: [],
      component: OrganizationSearchView,
      icon: organizationsMenuIcon,
      exact: true
    },
    {
      name: 'Org redirect',
      path: ORG_REDIRECT_URL,
      pages: [],
      component: OrgRedirect,
      hideFromMenu: true,
      exact: true
    },
    {
      name: 'Find Users',
      path: `${APP_PREFIX}/users`,
      pages: [],
      component: UserSearchView,
      icon: usersMenuIcon,
      exact: true
    },
    {
      name: 'Find Vendors',
      path: `${APP_PREFIX}/vendors`,
      pages: [],
      component: VendorView,
      icon: VendorIcon,
      exact: true
    },
    {
      name: 'Vendor page',
      path: VENDOR_VIEW_URL,
      exact: true,
      component: VendorPageInvestigationView,
      pages: [],
      hideFromMenu: true,
      backgroundColor: semanticTheme.dime.colors.background.secondary
    },
    {
      name: 'User page',
      path: `${APP_PREFIX}/users/:id`,
      exact: false,
      component: UserViewInvestigationView,
      pages: userViewRoutes,
      hideFromMenu: true,
      backgroundColor: semanticTheme.dime.colors.background.secondary
    }
  ]
};

export const ExtraComponent = () => (
  <Feedback slackChannelId={PATH_FINDER_FEEDBACK_CHANNEL} />
);
